import homePage from "@/views/defaultPages/HomePage.vue";
import pricingPage from "@/views/defaultPages/PricingPage.vue";
import contactPage from "@/views/defaultPages/ContactPage.vue";
import loginPage from "@/views/defaultPages/LoginPage.vue";
import setNewPassword from "@/views/defaultPages/SetNewPassword.vue";

export default [
  {
    path: "",
    name: "homePage",
    component: homePage,
    alias: ["/", "/home"],
    meta: { layout: "LayoutDefault" }
  },
  {
    path: "/pricing",
    name: "pricingPage",
    component: pricingPage,
    meta: { layout: "LayoutDefault" }
  },
  {
    path: "/contact",
    name: "contactPage",
    component: contactPage,
    meta: { layout: "LayoutDefault" }
  },
  {
    path: "/login",
    name: "loginPage",
    component: loginPage,
    meta: { layout: "LayoutLogin" }
  },
  {
    path: "/new-password/:token",
    name: "setNewPassword",
    component: setNewPassword,
    alias: ["/"],
    meta: { layout: "LayoutLogin" }
  }
];
